import React from "react";
import styled from "styled-components";
import { AccountState } from "Types/state";
import TermsAndPrivacyLinks from "./TermsAndPrivacyLinks";

const Root = styled("div")`
    color: ${(props) => props.theme.palette.grey[60]};
    font-size: 0.8em;
    font-weight: normal;
    margin: 1em 0;
    text-align: center;
`;

interface TermsAndPrivacyProps {
    account: AccountState;
}

const UsTermsAndPrivacy = ({ account }: TermsAndPrivacyProps) => {
    const disclaimer = (account && account.account_disclaimers && account.account_disclaimers.global_consent) || "";

    return (
        <Root>
            {disclaimer} <TermsAndPrivacyLinks />
        </Root>
    );
};

export default UsTermsAndPrivacy;
